import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, {
          value: _ctx.$t('nap.templateList')
        }, null, 8, ["value"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('nap.newCreate')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}